module.exports = __webpack_public_path__ + "static/media/优惠券.png";